module.exports = __webpack_public_path__ + "static/media/verticalLine.220840d5.svg";